/**
 * Directive: minus
 */
angular.module('acme.common.directive.minus', [])
.directive('minus', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/minus/minus.tpl.html',
      scope: {
        action: '&'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.minus = {

          model: "-",

          action: function() {
            if (typeof($scope.action) === 'function') {
              $scope.action();
            }
          }

        };

      }]

    };

}]);